import React, {PureComponent} from 'react';

import { Classes, Overlay, MenuItem, Button } from "@blueprintjs/core";

import {Select} from "@blueprintjs/select";

const countriesList = [
    {value: 10, text: 'USA'},
    {value: 14, text: 'Serbia'},
    {value: 18, text: 'Germany'}
];

export default class CostEstimateModal extends PureComponent{
    state={
        overlayIsOpen: false,
        selectedCountry: {value: 18, text: 'Germany'}
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }
    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){
        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }
    countryRenderer = (item, {modifiers, handleClick}) => {
        //{console.log('item: ',item)}
        return (
            <MenuItem
                key={item.text}
                text={item.text}
                value={item.text}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />
        )
    };
    countrySelect = async (item) => {
        await this.setState({ selectedCountry: item })
    }
    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel viber-modal-container">
                        <h2>Cost Estimate</h2>
                        <p className="text-lite">Remember, this is just en estimate, final cost may be different. Prices vary for different
                            destination countries.</p>

                        <div className="flex-row-wrapper margin-bottom-10" style={ { width: '100%' } }>
                            <p className="full-row-label">Majority Contacts Destination Country</p>
                            <div className="space-between">
                                <Select
                                    items={countriesList}
                                    itemRenderer={this.countryRenderer}
                                    onItemSelect={this.countrySelect}
                                    filterable={false}
                                >
                                    <Button text={this.state.selectedCountry.text} rightIcon="caret-down"></Button>

                                </Select>
                                <button
                                    className="btn-action dist-platf-button"
                                    disabled={false}
                                    onClick={(e) => {
                                        //console.log(e)
                                    }}>
                                    Calculate
                                </button>
                            </div>
                        </div>
                        <p><strong>Estimate Cost</strong></p>
                        <div className="cost-estimate-container space-between">
                            <p className="cost-value-text">
                                Message Recipients<br/>
                                <span>{this.props.numberOfRecipients}</span>
                            </p>
                            <p className="cost-value-text">
                                Total Estimate<br/>
                                <span>{this.props.numberOfRecipients * this.state.selectedCountry.value}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}